export default __webpack_public_path__ + "static/media/hero-mobile.c5ee8bf7.jpg";